import React, { ReactNode } from 'react';
import AdSlot from './AdSlot';

interface ContentLayoutProps {
  children: ReactNode;
  showSidebar?: boolean;
}

/**
 * ContentLayout component for article/tutorial pages
 * Includes a sticky right sidebar for desktop with ad slots
 */
const ContentLayout: React.FC<ContentLayoutProps> = ({ 
  children, 
  showSidebar = true 
}) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex gap-8">
        {/* Main Content Area */}
        <article className="flex-1 min-w-0">
          {children}
        </article>

        {/* Desktop Sidebar */}
        {showSidebar && (
          <aside className="hidden lg:block w-[300px] flex-shrink-0">
            <div 
              id="ad-sidebar-sticky" 
              className="sticky top-24 space-y-6"
            >
              {/* Sticky Sidebar Ad */}
              <AdSlot 
                id="ad-sidebar-top" 
                variant="rectangle" 
              />
              
              {/* Additional Sidebar Content */}
              <div className="p-4 bg-muted/30 rounded-lg border border-border">
                <h4 className="font-semibold text-sm mb-3">Quick Links</h4>
                <ul className="space-y-2 text-sm">
                  <li>
                    <a href="/deepseek-api" className="text-primary hover:underline">
                      API Documentation
                    </a>
                  </li>
                  <li>
                    <a href="/deepseek-r1" className="text-primary hover:underline">
                      DeepSeek R1 Guide
                    </a>
                  </li>
                  <li>
                    <a href="/deepseek-vs-chatgpt" className="text-primary hover:underline">
                      DeepSeek vs ChatGPT
                    </a>
                  </li>
                  <li>
                    <a href="/blog" className="text-primary hover:underline">
                      All Tutorials
                    </a>
                  </li>
                </ul>
              </div>

              {/* Second Sidebar Ad */}
              <AdSlot 
                id="ad-sidebar-bottom" 
                variant="sidebar" 
              />
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

export default ContentLayout;
